import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
    AddAdditionalCostProductRequest,
    AdditionalCostHistory,
    AdditionalCostProductResponse,
    AddProductRequest,
    ProductResponse,
    ShoppingCategory,
    ShoppingProductsResponse,
    UpdateAdditionalCostProductRequest,
    UpdateProductRequest
} from '../interfaces/cost-type-config.interface';

@Injectable({
    providedIn: 'root'
})
export class CostTypeConfigService {
    http = inject(HttpClient);
    baseUrl = environment.apiUrl + '/product';
    baseUrlForAdditionalCost = environment.apiUrl + '/additional-cost';

    getCostProducts(): Observable<ProductResponse[]> {
        const apiUrl = `${this.baseUrl}/shopping-products`;
        return this.http.get<ProductResponse[]>(apiUrl);
    }
    getProductsCategory(): Observable<ShoppingCategory[]> {
        const apiUrl = `${this.baseUrl}/shopping-categories`;
        return this.http.get<ShoppingCategory[]>(apiUrl);
    }
    addCostProduct(productRequest: AddProductRequest) {
        const apiUrl = `${this.baseUrl}/shopping-products`;
        return this.http.post(apiUrl, productRequest);
    }
    editCostProduct(producRequest: UpdateProductRequest) {
        const apiUrl = `${this.baseUrl}/shopping-products`;
        return this.http.put(apiUrl, producRequest);
    }
    getAddtionalCostProducts(): Observable<AdditionalCostProductResponse[]> {
        const apiUrl = `${this.baseUrlForAdditionalCost}/products`;
        return this.http.get<AdditionalCostProductResponse[]>(apiUrl);
    }
    addAdditionalCostProduct(productRequest: AddAdditionalCostProductRequest) {
        const apiUrl = `${this.baseUrlForAdditionalCost}/products`;
        return this.http.post(apiUrl, productRequest);
    }
    getModalInfo(): Observable<ShoppingProductsResponse> {
        const apiUrl = `${this.baseUrlForAdditionalCost}/modal-information`;
        return this.http.get<ShoppingProductsResponse>(apiUrl);
    }
    editAdditionalCostProduct(producRequest: UpdateAdditionalCostProductRequest) {
        const apiUrl = `${this.baseUrlForAdditionalCost}/products`;
        return this.http.put(apiUrl, producRequest);
    }
    sendToArchive(id: number) {
        const apiUrl = `${this.baseUrlForAdditionalCost}/archive/${id}`;
        return this.http.put(apiUrl, id);
    }
    showHistories(id: number): Observable<AdditionalCostHistory[]> {
        const apiUrl = `${this.baseUrlForAdditionalCost}/histories/${id}`;
        return this.http.get<AdditionalCostHistory[]>(apiUrl);
    }
    getArchivedProducts(): Observable<AdditionalCostProductResponse[]> {
        const apiUrl = `${this.baseUrlForAdditionalCost}/archived-products`;
        return this.http.get<AdditionalCostProductResponse[]>(apiUrl);
    }
}
